module.exports = __webpack_public_path__ + "static/media/privacy-lock.c6d16d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/privacy-lock.png
// module id = 1185
// module chunks = 0